<template>
  <div class="webcams-container" :class="{ 'summer-webcams' : isSummerResort}">
    <h1 class="title">
      {{ $t('Cams') }}
    </h1>
    <hooper ref="hooper" :settings="webcamSettings">
      <hooper-slide v-for="webcam in webcams" :key="webcam.Title">
        <Webcam :webcam="webcam" :webcamTitleField="webcamTitleField" v-on:showWebcamModal="showWebcamModal"></Webcam>
      </hooper-slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
    <WebcamModal
      :webcam="currentWebcam"
      :webcamTitleField="webcamTitleField"
      v-if="showModal"
      v-on:closeModal="closeModal">
    </WebcamModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  Hooper,
  Slide as HooperSlide,
  Navigation as HooperNavigation,
} from 'hooper';
import Webcam from './Webcams/WebcamHooper.vue';
import WebcamModal from './Webcams/WebcamModal.vue';

export default {
  name: 'WebcamsHooper',
  components: {
    Hooper,
    HooperSlide,
    HooperNavigation,
    Webcam,
    WebcamModal,
  },
  data() {
    return {
      container: null,
      camSlide: null,
      currentWebcam: null,
      showModal: false,
      translateY: 0,
    };
  },
  computed: {
    ...mapGetters(['webcams', 'webcamTitleField', 'isSummerResort', 'webcamSettings']),
  },
  watch: {
    webcams() {
      const app = this;
      setTimeout(() => { app.$refs.hooper.update(); }, 750);
    },
  },
  methods: {
    showWebcamModal(vueEvent) {
      this.currentWebcam = vueEvent.webcam;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
.webcams-container {
  background-color: $white;
  height: 100%;
  overflow: hidden;
  padding: 0px 20px 0;
  position: relative;
  &.summer-webcams {
    .hooper {
      max-height: 90%;
    }
  }
  .hooper {
    height: 100%;
    max-height: 92%;
    .hooper-slide {
      @media (min-width: $tablet) {
        margin-bottom: 10px;
      }
      @media (min-width: $tablet-landscape) {
        margin-bottom: 15px;
      }
    }
    .hooper-liveregion {
      display: none;
    }
    .hooper-list {
      button {
        background-color: $alert-bar-background;
        fill: $white;
        height: auto;
        padding: 0 0;
        opacity: 1;
        position: absolute;
        width: 25%;
        z-index: 5;
        transition: opacity ease-in-out 0.25s;
        &.is-disabled {
          opacity: 0;
          pointer-events: none;
        }
        svg {
          height: 35px;
          width: 35px;
        }
        &.hooper-prev {
          left: 37.5%;
          top: 0;
        }
        &.hooper-next {
          left: 37.5%;
          bottom: 0px;
        }
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Cams": "CAMÉRAS"
}
</i18n>
